/* Navigation only: original editors own form state and ordering. */
(() => {
  if (window.hiveToolUIV70) return;
  window.hiveToolUIV70 = true;
  const moveTo = (target) => {
    if (!target) return;
    target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
    if (!target.matches('button,input,select,textarea,a,summary')) target.setAttribute('tabindex','-1');
    target.focus({preventScroll:true});
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tool-jump]');
    if (!button) return;
    const root = button.closest('[data-instant-quote],[data-jersey-maker]');
    if (!root) return;
    const targets = {upload:'[data-iq-replace]:not([hidden])',material:'[data-iq-materials]',quote:'.iq__quote',help:'[data-iq-review]',design:'.jm-controls',preview:'.jm-stage'};
    if (button.dataset.toolJump === 'upload') targets.upload = root.querySelector('[data-iq-filebar]')?.hidden ? '[data-iq-browse]' : '[data-iq-replace]';
    if (button.dataset.toolJump === 'material' && root.querySelector('[data-mold-enable]')?.checked) targets.material='[data-mold-panel]';
    const target = root.querySelector(targets[button.dataset.toolJump] || '[data-tool-missing]');
    if (button.dataset.toolJump === 'help' && target) target.open = true;
    moveTo(target);
  });
  const showFormFeedback = (root) => {
    root.querySelectorAll('[data-iq-review]').forEach(panel => {
      if (panel.querySelector('.iq__success,.iq__form-error')) panel.open = true;
    });
  };
  showFormFeedback(document);
  document.addEventListener('shopify:section:load', event => showFormFeedback(event.target));
})();
